import React from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import withStyles from '@material-ui/core/styles/withStyles';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import Grid from 'react-mui-lib/grid-widgets/Grid';
import Search from 'react-mui-lib/grid-widgets/filters/Search';
import Select from 'react-mui-lib/grid-widgets/filters/Select';
import registry from 'react-mui-lib/registry';

import { format_timestamp, has_superaccess } from '../utils';
import NotificationDialog from './NotificationDialog';


const StyledIconButton = withStyles(theme => ({
    root: {
        '&:hover': {
            color: theme.palette.primary.main
        }
    }
}))(IconButton);


const styles = theme => ({
    gameGrid: {
        '& table': {
            tableLayout: 'auto',
            width: '100%'
        },
        '& th, & td': {
            padding: '4px 8px',
            overflow: 'hidden'
        },
        '& th': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: '1.2',
            fontSize: '0.75rem'
        },
        '& td': {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        },
        '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
        '& thead th:first-child, & tbody td:first-child': {
            width: '40%',
            maxWidth: '400px'
        },
        '& thead th:nth-child(2), & tbody td:nth-child(2), & thead th:nth-child(3), & tbody td:nth-child(3)': {
            width: '150px',
            maxWidth: '150px'
        },
        '& thead th:nth-child(5), & thead th:nth-child(6), & thead th:nth-child(7), & tbody td:nth-child(5), & tbody td:nth-child(6), & tbody td:nth-child(7)': {
            width: '60px',
            padding: '4px 2px',
            textAlign: 'center'
        },
        '& thead th:last-child, & tbody td:last-child': {
            width: '1%',
            whiteSpace: 'nowrap',
            overflow: 'visible'
        }
    }
});


class GameGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            busyId: null,
            paidGameId: null,
            paidGameName: null,
            extendedGameId: null,
            extendedGameName: null,
            extendedGameEndDate: null,
            deleteGame: null,
            editBlocked: null
        };

        this.controller = registry.get('game_grid_controller');
        this.franchise_list_controller = registry.get('franchise_list_controller');
    }

    parsePaymentReturn() {
        const c = this;
        const params = new URLSearchParams((c.props.location && c.props.location.search) || '');
        const paidId = params.get('game_paid');
        const extendedId = params.get('game_extended');

        if (paidId) {
            const game = c.controller.getRowsForDisplay().find(r => r.id === paidId);
            c.setState({
                paidGameId: paidId,
                paidGameName: game ? game.name : ''
            });
        } else if (extendedId) {
            const game = c.controller.getRowsForDisplay().find(r => r.id === extendedId);
            c.setState({
                extendedGameId: extendedId,
                extendedGameName: game ? game.name : '',
                extendedGameEndDate: game ? game.end_date : null
            });
        }
    }

    closePaidDialog() {
        const c = this;
        c.setState({ paidGameId: null, paidGameName: null });
        c.props.history.replace('/admin/games');
        c.controller.load();
    }

    closeExtendedDialog() {
        const c = this;
        c.setState({ extendedGameId: null, extendedGameName: null, extendedGameEndDate: null });
        c.props.history.replace('/admin/games');
        c.controller.load();
    }

    confirmDelete(row) {
        const c = this;
        c.setState({ deleteGame: row });
    }

    closeDeleteDialog() {
        const c = this;
        c.setState({ deleteGame: null });
    }

    isGameEditable(row) {
        if (has_superaccess()) {
            return true;
        }
        const now = new Date();
        const started = row.start_date && new Date(row.start_date) <= now;
        return !started || !row.is_published;
    }

    onEdit(row) {
        const c = this;
        if (c.isGameEditable(row)) {
            c.props.history.push(`/admin/game/${row.id}/edit`);
        } else {
            c.setState({ editBlocked: row });
        }
    }

    sendMessages(row) {
        const c = this;
        c.refs.notification_dialog.open(row);
    }

    closeEditBlocked() {
        const c = this;
        c.setState({ editBlocked: null });
    }

    deleteGame() {
        const c = this;
        const row = c.state.deleteGame;
        if (!row) return;

        const rest_client = registry.get('rest_client');
        const message_controller = registry.get('message_controller');

        c.setState({ busyId: row.id, deleteGame: null });

        rest_client.deleteById('game', row.id).then(() => {
            c.setState({ busyId: null });
            message_controller.showInfo('Игра удалена');
            window.location.href = '/admin/games';
        }, error => {
            c.setState({ busyId: null });
            message_controller.showException('Ошибка удаления игры', error);
        });
    }

    componentDidMount() {
        const c = this;
        c.parsePaymentReturn();
    }

    componentDidUpdate(prevProps) {
        const c = this;
        const prevSearch = (prevProps.location && prevProps.location.search) || '';
        const newSearch = (c.props.location && c.props.location.search) || '';
        if (newSearch !== prevSearch) {
            c.parsePaymentReturn();
        }
    }

    pay(row) {
        const c = this;
        const rest_client = registry.get('rest_client');
        const message_controller = registry.get('message_controller');

        c.setState({ busyId: row.id });

        rest_client.post(`game/${row.id}/pay`).then(json => {
            c.setState({ busyId: null });
            if (json.payment_url) {
                window.open(json.payment_url, '_blank');
            }
        }, error => {
            c.setState({ busyId: null });
            message_controller.showException('Ошибка оплаты', error);
        });
    }

    extend(row) {
        const c = this;
        const rest_client = registry.get('rest_client');
        const message_controller = registry.get('message_controller');

        c.setState({ busyId: row.id });

        rest_client.post(`game/${row.id}/extend`).then(json => {
            c.setState({ busyId: null });
            if (json.payment_url) {
                window.open(json.payment_url, '_blank');
            }
        }, error => {
            c.setState({ busyId: null });
            message_controller.showException('Ошибка продления', error);
        });
    }

    togglePublish(row) {
        const c = this;
        const rest_client = registry.get('rest_client');
        const message_controller = registry.get('message_controller');
        const newValue = !row.is_published;

        c.setState({ busyId: row.id });

        rest_client.post(
            `game/${row.id}/publish`,
            { is_published: newValue }
        ).then(json => {
            c.setState({ busyId: null });
            message_controller.showInfo(newValue ? 'Игра опубликована' : 'Игра снята с публикации');

            const rows = c.controller.state.rows || c.controller.getRowsForDisplay();
            const total = c.controller.getTotalRows();
            const updatedRows = rows.map(r =>
                r.id === row.id ? Object.assign({}, r, { is_published: newValue }) : r
            );

            c.controller.dispatch({
                type: 'LOAD_SUCCESS',
                data: { data: updatedRows, count: total }
            });
        }, error => {
            c.setState({ busyId: null });
            message_controller.showException('Ошибка изменения публикации', error);
        });
    }

    render() {
        const c = this;

        const columns = [{
            key: 'name',
            label: 'Название'
        }, {
            key: 'start_date',
            label: 'Дата начала',
            template: ({val, row}) =>
                <span>{format_timestamp(val)}</span>
        }, {
            key: 'end_date',
            label: 'Дата окончания',
            template: ({val, row}) =>
                <span>{format_timestamp(val)}</span>
        }, {
            key: 'franchise.locality.name',
            label: 'Город'
        }, {
            key: 'rounds_count',
            label: 'Задания'
        }, {
            key: 'participants_count',
            label: 'Участники'
        }, {
            key: 'n_winners',
            label: 'Победители'
        }, {
            key: 'franchise.organizer_name',
            label: 'Автор',
            include_if: has_superaccess(),
            template: ({val, row}) =>
                <span>{val || (row.franchise && row.franchise.organizer_phone) || '—'}</span>
        }, {
            key: 'franchise.organizer_phone',
            label: 'Телефон',
            include_if: has_superaccess()
        }, {
            key: 'actions',
            label: 'Действия',
            sortable: false,
            template: ({row}) => {
                const isSuper = has_superaccess();
                const isNovice = !row.plan || row.plan === 'novice';
                const isPaid = !!row.paid_at;
                const businessActive = window.Params && window.Params.franchise && window.Params.franchise.business_expires_at &&
                    new Date(window.Params.franchise.business_expires_at) > new Date();
                const now = new Date();
                const started = row.start_date && new Date(row.start_date) <= now;
                const roundsOk = (row.rounds_count || 0) >= 3;
                const busy = c.state.busyId === row.id;

                let publishDisabled;
                let publishTooltip;
                if (row.is_published) {
                    publishDisabled = !isSuper && started && row.game_type !== 'TOUR';
                    publishTooltip = publishDisabled ? 'Нельзя снять с публикации начавшуюся игру' : 'Снять с публикации';
                } else if (isSuper) {
                    publishDisabled = false;
                    publishTooltip = 'Опубликовать';
                } else {
                    if (!roundsOk) {
                        publishDisabled = true;
                        publishTooltip = 'Нужно не менее 3 заданий';
                    } else if (!isNovice && !isPaid && !businessActive) {
                        publishDisabled = true;
                        publishTooltip = 'Сначала оплатите игру';
                    } else if (started) {
                        publishDisabled = true;
                        publishTooltip = 'Нельзя опубликовать начавшуюся игру';
                    } else {
                        publishDisabled = false;
                        publishTooltip = 'Опубликовать';
                    }
                }

                return <div style={{whiteSpace: 'nowrap'}}>
                    <Tooltip title="Редактировать">
                        <StyledIconButton
                            disabled={busy}
                            onClick={() => c.onEdit(row)}
                        >
                            <Icon>edit</Icon>
                        </StyledIconButton>
                    </Tooltip>

                    <Tooltip title="Участники">
                        <StyledIconButton
                            disabled={busy}
                            onClick={() => c.props.history.push(`/admin/game/${row.id}/participants`)}
                        >
                            <Icon>people</Icon>
                        </StyledIconButton>
                    </Tooltip>

                    <Tooltip title="Отправить сообщения">
                        <StyledIconButton
                            disabled={busy}
                            onClick={() => c.sendMessages(row)}
                        >
                            <Icon>send</Icon>
                        </StyledIconButton>
                    </Tooltip>

                    {!isNovice && !isPaid && !businessActive && (
                        <Tooltip title="Оплатить">
                            <StyledIconButton
                                disabled={busy}
                                onClick={() => c.pay(row)}
                            >
                                <Icon>payment</Icon>
                            </StyledIconButton>
                        </Tooltip>
                    )}

                    {!isNovice && businessActive && (
                        <Tooltip title="Тариф Агентство">
                            <Chip label="Агентство" color="primary" size="small" />
                        </Tooltip>
                    )}

                    {!isNovice && !businessActive && isPaid && (() => {
                        const isTour = row.game_type === 'TOUR';
                        const isExpert = row.plan === 'expert';
                        const nowMs = new Date().getTime();
                        const endMs = row.end_date ? new Date(row.end_date).getTime() : null;
                        const threeDaysMs = 3 * 24 * 60 * 60 * 1000;
                        const extendable = isTour && isExpert && endMs &&
                            (endMs <= nowMs || endMs - nowMs <= threeDaysMs);

                        if (extendable) {
                            return <Tooltip title="Продлить экскурсию на 30 дней">
                                <Chip label="Продлить" color="primary" size="small" onClick={() => c.extend(row)} />
                            </Tooltip>;
                        }
                        return <Tooltip title="Оплачено">
                            <Chip label="Оплачено" color="primary" size="small" />
                        </Tooltip>;
                    })()}

                    <Tooltip title={publishTooltip}>
                        <span>
                            <StyledIconButton
                                disabled={busy || publishDisabled}
                                onClick={() => c.togglePublish(row)}
                            >
                                <Icon color={row.is_published ? 'primary' : 'action'}>
                                    {row.is_published ? 'visibility' : 'visibility_off'}
                                </Icon>
                            </StyledIconButton>
                        </span>
                    </Tooltip>

                    <Tooltip title="Удалить">
                        <StyledIconButton
                            disabled={busy}
                            onClick={() => c.confirmDelete(row)}
                        >
                            <Icon>delete</Icon>
                        </StyledIconButton>
                    </Tooltip>
                </div>;
            }
        }];

        return <React.Fragment>
            <div className={c.props.classes.gameGrid}>
            <Grid controller={c.controller}
                  columns={columns}
                  title="Игры"
                  minWidth={1100}>
                <Search controller={c.controller}/>
                { has_superaccess() &&
                    <Select controller={c.controller}
                            name="franchise_id"
                            label="- Автор -"
                            options={c.franchise_list_controller.getAsOptions()}/>
                }
            </Grid>
            </div>

            <Dialog open={!!c.state.paidGameId} onClose={() => c.closePaidDialog()}>
                <DialogTitle>Игра оплачена</DialogTitle>
                <DialogContent>
                    {c.state.paidGameName
                        ? `Игра «${c.state.paidGameName}» успешно оплачена. Теперь можно опубликовать игру.`
                        : 'Игра успешно оплачена. Теперь можно опубликовать игру.'}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => c.closePaidDialog()} color="primary" variant="contained">
                        ОK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!c.state.extendedGameId} onClose={() => c.closeExtendedDialog()}>
                <DialogTitle>Экскурсия продлена</DialogTitle>
                <DialogContent>
                    {c.state.extendedGameName
                        ? `Экскурсия «${c.state.extendedGameName}» продлена до ${format_timestamp(c.state.extendedGameEndDate)}.`
                        : 'Экскурсия успешно продлена.'}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => c.closeExtendedDialog()} color="primary" variant="contained">
                        ОK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!c.state.deleteGame} onClose={() => c.closeDeleteDialog()}>
                <DialogTitle>Удалить игру</DialogTitle>
                <DialogContent>
                    {c.state.deleteGame
                        ? `Игра «${c.state.deleteGame.name}» будет удалена вместе со всеми заданиями, участниками и файлами. Продолжить?`
                        : 'Игра будет удалена. Продолжить?'}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => c.closeDeleteDialog()}>
                        Отмена
                    </Button>
                    <Button onClick={() => c.deleteGame()} color="secondary" variant="contained">
                        Удалить
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!c.state.editBlocked} onClose={() => c.closeEditBlocked()}>
                <DialogTitle>Редактирование недоступно</DialogTitle>
                <DialogContent>
                    {c.state.editBlocked
                        ? `Игра «${c.state.editBlocked.name}» уже началась. Редактирование разрешено только до начала игры.`
                        : 'Редактирование этой игры недоступно.'}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => c.closeEditBlocked()} color="primary" variant="contained">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <NotificationDialog ref="notification_dialog" />
        </React.Fragment>;
    }

    componentWillMount() {
        const c = this;
        c.controller.loadIfNeeded();
    }
}

export default withStyles(styles)(GameGrid);
